import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import {ADD_OBJECT_ATTEMPT_LS, GET_QUERY_DATA_ATTEMPT_LS,ADD_UPDATE_MAP_ATTEMPT_LS } from '../Actions/LogisticActions'
import { GET_REQUEST_PARAMETER_API } from '../Services/API'
import { UNAUTHORIZED_HTTP_CODE, UNAUTHORIZED_CASE } from '../Actions/AuthorizationActions'


function* GeneralGet_Saga(action) {
    let MapKey = action.Container.Key
    let MapData = action.Container.Data

    let CurrentMapData = localStorage.getItem(MapKey)

    console.log('CurrentMapData')
    console.log(MapKey)
    console.log(Object.entries(localStorage))

    console.log(CurrentMapData)
    console.log(JSON.parse(CurrentMapData))
    
}

function* UpdateMap_Saga(action) {
    let MapKey = action.Container.Key
    let MapData = action.Container.Data

    let CurrentMapData = localStorage.getItem(MapKey)

    console.log('UpdateMap_Saga')
    console.log(MapKey)
    console.log(MapData)
    console.log(CurrentMapData)

    if(!CurrentMapData ||CurrentMapData == null || CurrentMapData == 'undefined'){
        let SaveData = ({
            Id: MapData.Id, 
            Answers: MapData.Answers
        })

        localStorage.setItem(MapKey, JSON.stringify(SaveData))
    }
    else{
        CurrentMapData = JSON.parse(CurrentMapData)

        let NewAnswer = MapData.Answers[0]
        let CurrentAnswer = CurrentMapData.Answers.filter((a) => a.ElementId == MapData.Answers[0].ElementId)[0]
        let Answer = NewAnswer
        let Answers = CurrentMapData.Answers.filter((a) => a.ElementId != MapData.Answers[0].ElementId)

        if(CurrentAnswer){
            if(CurrentAnswer.Progress.length < NewAnswer.Progress.length){
                Answer.Progress = NewAnswer.Progress
            }
            else{
                Answer.Progress = CurrentAnswer.Progress
            }

        }
        
        Answers = [...Answers, Answer]

        let SaveData = ({
            Id: MapData.Id, 
            Answers: Answers
        })

        localStorage.setItem(MapKey, JSON.stringify(SaveData))

    }
}


export default function* LocalStorageSaga(){
    yield takeLatest(GET_QUERY_DATA_ATTEMPT_LS, GeneralGet_Saga)
    yield takeLatest(ADD_UPDATE_MAP_ATTEMPT_LS, UpdateMap_Saga)


}